"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1528],{

/***/ 57405:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(7125);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _react = _interopRequireDefault(__webpack_require__(34885));
var _Box = _interopRequireDefault(__webpack_require__(40300));
var _langLibrary = _interopRequireDefault(__webpack_require__(51493));
var __jsx = _react["default"].createElement;
var MinicartContent = function MinicartContent(props) {
  var progressBar = props.progressBar,
    productRows = props.productRows,
    orderSummary = props.orderSummary,
    itemsAmountInCart = props.itemsAmountInCart;
  var translations = {
    yourCart: (0, _langLibrary["default"])("Your cart"),
    noProducts: (0, _langLibrary["default"])("No products in cart"),
    noReservationInfo: (0, _langLibrary["default"])("Do not hesitate")
  };
  return __jsx(_Box["default"], {
    sx: {
      display: "flex",
      flexDirection: "column",
      pb: "s10"
    }
  }, __jsx(_Box["default"], {
    as: "span",
    sx: {
      font: "heading2",
      mb: "s10",
      textAlign: "center",
      color: "main"
    }
  }, " ", translations.yourCart, " (", itemsAmountInCart, ")"), itemsAmountInCart === 0 && __jsx(_Box["default"], {
    as: "span",
    sx: {
      textAlign: "center",
      font: "base_sans",
      color: "main"
    }
  }, translations.noProducts), itemsAmountInCart > 0 && __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      mb: "s8"
    }
  }, progressBar), __jsx(_Box["default"], {
    sx: {
      textAlign: "center",
      font: "s_caps",
      color: "main",
      mb: "s8"
    }
  }, translations.noReservationInfo), __jsx(_Box["default"], {
    sx: {
      mb: "s8"
    }
  }, productRows.map(function (product, index) {
    var _product$props;
    return __jsx(_Box["default"], {
      "data-test": "product-mini-cart",
      key: "".concat(index).concat(product === null || product === void 0 ? void 0 : (_product$props = product.props) === null || _product$props === void 0 ? void 0 : _product$props.product.sku),
      sx: {
        py: "s8",
        borderStyle: "solid",
        borderBottomWidth: "1px",
        borderColor: "neutral"
      }
    }, product);
  })), __jsx(_Box["default"], null, orderSummary)));
};
var _default = MinicartContent;
exports.Z = _default;

/***/ }),

/***/ 91528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34885);
/* harmony import */ var _deosite_components_new_MinicartContent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57405);
/* harmony import */ var _deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51586);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var MinicartContent = function(props) {
    var propsExt = _objectSpread({}, props, {
        checkoutButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_buttons_Button__WEBPACK_IMPORTED_MODULE_3__["default"], {})
    });
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deosite_components_new_MinicartContent__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, propsExt)));
};
/* harmony default export */ __webpack_exports__["default"] = (MinicartContent);


/***/ })

}]);